// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"0a5c3203","796":"d496f9a2"}[chunkId] + ".chunk.js";
};